import { XIcon } from 'lucide-react';
import * as React from 'react';

import { Button } from '@/shared/ui/button';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarRail,
  useSidebar,
} from '@/shared/ui/sidebar';

import { useAuth } from './auth-provider';
import { useLanguage } from './language-provider';
import { LanguageSelect } from './language-select';
import { UserSettingsDropdown } from './user-settings-dropdown';

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { isGuest } = useAuth();
  const { language, handleLanguageChange } = useLanguage();

  const { toggleSidebar } = useSidebar();

  return (
    <Sidebar {...props}>
      <SidebarHeader>
        <div className="flex justify-end">
          <Button
            variant="ghost"
            size="icon"
            className="[&_svg]:size-8"
            onClick={toggleSidebar}
          >
            <XIcon size={32} />
          </Button>
        </div>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Main</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem>
                <LanguageSelect value={language} onValueChange={handleLanguageChange} />
              </SidebarMenuItem>

              {!isGuest && (
                <SidebarMenuItem>
                  <UserSettingsDropdown />
                </SidebarMenuItem>
              )}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarRail />
    </Sidebar>
  );
}
